import React, { useState, useEffect } from "react";
import { getActiveGame, redicrectAuth, fetchBalance } from "../../api";
import "./Menu.css";

const BalanceView = ({}) => {
  const [balance, setBalance] = useState(localStorage.getItem("balance"));
  useEffect(() => {
    fetchBalance(setBalance, (e) => {});
  });
  const onClick = () => {
    window.location.href = `/walletop`;
  };
  return (
    <button className="balancecontainer" onClick={onClick}>
      <img src="/ton.png" alt="toncoin" className="image" />
      <div className="text">{parseFloat(balance).toFixed(2)}</div>
      <img src="wallet.svg" alt="walletsvg" className="icon" />
    </button>
  );
};

const ActionButton = ({ text, image, gradient, onClick }) => {
  return (
    <button
      className="custom-button"
      onClick={onClick}
      style={{
        background: gradient,
      }}
    >
      <div className="content">
        <img className="imagebutton" src={image} />
        <div className="textbutton">{text}</div>
      </div>
    </button>
  );
};

const ActionButtons = ({ wConnected, onError }) => {
  const [activeGame, setActiveGame] = useState("");

  useEffect(() => {
    getActiveGame(setActiveGame, onError);
  }, []);

  const newGameClick = () => {
    window.location.href = `/newgame`;
  };
  const returnToGameClick = () => {
    window.location.href = `/game/${activeGame}`;
  };
  const joinGameClick = () => {
    window.location.href = `/join`;
  };
  const findGameClick = () => {
    window.location.href = `/find`;
  };

  const walletWarning = () => {
    alert("Сначала подключите кошелек");
  };

  return (
    <div className="button-container">
      <ActionButton
        text={"Find Game"}
        image={"/crossed-swords.svg"}
        gradient={"linear-gradient(45deg, #FF2525 0%, #FFE53B 100%)"}
        onClick={findGameClick}
      />
      {!activeGame && (
        <ActionButton
          text={"New Game"}
          image={"/die.svg"}
          gradient={"linear-gradient(45deg, #FFE53B 0%, #FC00FF 100%)"}
          onClick={newGameClick}
        />
      )}
      {activeGame && (
        <ActionButton
          text={"Return to Game"}
          image={"/die.svg"}
          gradient={"linear-gradient(45deg, #FFE53B 0%, #FC00FF 100%)"}
          onClick={returnToGameClick}
        />
      )}
      <ActionButton
        text={"Join Game"}
        image={"/vg.png"}
        gradient={"linear-gradient(45deg, #FC00FF 0%, #00DBDE 110%)"}
        onClick={joinGameClick}
      />
    </div>
  );
};

const MenuView = ({}) => {
  if (redicrectAuth()) {
    window.location.href = "/";
  }
  const [error, setError] = useState("");

  return (
    <div>
      <BalanceView />
      {error && <p className="error">{error}</p>}
      <ActionButtons wConnected={true} onError={setError} />
    </div>
  );
};

export default MenuView;
